exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".index-module__wrapper___oR3M5{display:grid;gap:1.5rem}@media screen and (min-width:1325px){.index-module__wrapper___oR3M5{grid-template-columns:300px auto}}@media screen and (min-width:1600px){.index-module__wrapper___oR3M5{grid-template-columns:330px auto}}.index-module__wrapper___oR3M5.index-module__school___1qqh9{grid-template-columns:1fr}", ""]);

// exports
exports.locals = {
	"wrapper": "index-module__wrapper___oR3M5",
	"school": "index-module__school___1qqh9"
};